<div class="banner-container">
  <mat-card *ngIf="open; else closed">
    <mat-card-content>
      <div class="text-container">
        <ng-container *ngIf="imageURL">
          <img [src]="imageURL" />
        </ng-container>
        <div>
          <div class="title">{{ title }}</div>
          <div class="description">{{ description }}</div>
        </div>
        <button (click)="toggle()" mat-icon-button><mat-icon>close</mat-icon></button>
      </div>
      <div class="cta">
        <button color="primary" mat-flat-button *ngIf="buttonText?.length > 0" (click)="buttonClick.emit()">
          {{ buttonText }}
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #closed>
  <div (click)="toggle()" class="link-container">
    <mat-icon>info</mat-icon>
    What's this?
  </div>
</ng-template>
